/**
 * Copyright Open Logistics Foundation
 *
 * Licensed under the Open Logistics Foundation License 1.3.
 * For details on the licensing terms, see the LICENSE file.
 * SPDX-License-Identifier: OLFL-1.3
 */

export enum ActionType {
    Creation = 'Creation',
    Edit = 'Edit',
    Share_Internal = 'Share_Internal',
    Share_External = 'Share_External',
    Share_Guest = 'Share_Guest',
}
